import {Button, Card} from 'platform/components';
import {Heading, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

interface LeasingEmptyStateProps {
  isCreateAllowed: boolean;
  onConfigureLeasing: () => void;
}

export function LeasingEmptyState(props: LeasingEmptyStateProps) {
  return (
    <Card variant="inlineGrey">
      <VStack spacing={4} align="center">
        <Heading size={4}>{i18n.t('page.vehicle.financingAndLeasing.noLeasing')}</Heading>
        <Text color="secondary">
          {i18n.t('page.vehicle.financingAndLeasing.noLeasingExplanation')}
        </Text>
        <Button
          title={i18n.t('page.vehicle.financingAndLeasing.configureLeasing')}
          isDisabled={!props.isCreateAllowed}
          onClick={props.onConfigureLeasing}
        />
      </VStack>
    </Card>
  );
}
